var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center w-100" },
          [
            _c(
              "b-button",
              {
                staticClass: "mr-3",
                attrs: { variant: "link" },
                on: {
                  click: function($event) {
                    return _vm.onBack()
                  }
                }
              },
              [
                _c("v-icon", {
                  attrs: { name: "buttons/chevrons_left", size: 13 }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.isBusy
              ? _c("h4", { attrs: { id: "user-ellipsis-loading" } }, [
                  _vm._v("Загрузка пользователя")
                ])
              : _c("h4", [
                  _vm._v(
                    _vm._s(_vm.user.name ? _vm.user.name : "Новый пользователь")
                  )
                ]),
            _vm._v(" "),
            !_vm.isBusy
              ? _c(
                  "span",
                  {
                    class: [
                      "custom-tag ml-3",
                      _vm.user.active ? "tag-success" : "tag-warning"
                    ]
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.user.active ? "Активен" : "Неактивен") +
                        "\n      "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "custom-btn-primary ml-auto",
                attrs: { disabled: _vm.loading },
                on: {
                  click: function($event) {
                    return _vm.onSubmit()
                  }
                }
              },
              [
                _vm.loading
                  ? _c("b-spinner", { attrs: { small: "" } })
                  : _vm._e(),
                _vm._v(" "),
                _c("v-icon", { attrs: { name: "buttons/check", size: 13 } }),
                _vm._v("\n        Сохранить\n      ")
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-body", staticStyle: { "overflow-y": "auto" } },
        [
          _c("b-skeleton-wrapper", {
            attrs: { loading: _vm.isBusy },
            scopedSlots: _vm._u([
              {
                key: "loading",
                fn: function() {
                  return [
                    _c(
                      "b-tabs",
                      { attrs: { card: "" } },
                      [
                        _c("b-tab", {
                          attrs: { disabled: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function() {
                                return [
                                  _c("v-icon", {
                                    staticClass: "mr-2",
                                    attrs: { name: "tabs/user", size: 13 }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Учётные данные")])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("b-tab", {
                          attrs: { disabled: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function() {
                                return [
                                  _c("v-icon", {
                                    staticClass: "mr-2",
                                    attrs: { name: "navbar/roles", size: 13 }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Права доступа")])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("b-tab", {
                          attrs: { disabled: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function() {
                                return [
                                  _c("v-icon", {
                                    staticClass: "mr-2",
                                    attrs: { name: "tabs/link", size: 13 }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Связи")])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "p-3" },
                      [
                        _c(
                          "b-col",
                          { attrs: { lg: "6" } },
                          [
                            _c(
                              "b-card",
                              { staticClass: "custom-card" },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c("b-skeleton", {
                                          staticClass: "mb-2",
                                          attrs: { width: "29%", height: "24%" }
                                        }),
                                        _vm._v(" "),
                                        _c("b-skeleton", {
                                          attrs: {
                                            type: "input",
                                            width: "100%",
                                            height: "45%"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "mb-2" },
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c("b-skeleton", {
                                          staticClass: "mb-2",
                                          attrs: { width: "30%", height: "24%" }
                                        }),
                                        _vm._v(" "),
                                        _c("b-skeleton", {
                                          attrs: {
                                            type: "input",
                                            width: "100%",
                                            height: "45%"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "mb-2" },
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c("b-skeleton", {
                                          staticClass: "mb-2",
                                          attrs: { width: "30%", height: "24%" }
                                        }),
                                        _vm._v(" "),
                                        _c("b-skeleton", {
                                          attrs: {
                                            type: "input",
                                            width: "100%",
                                            height: "45%"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("h5", { staticClass: "my-2" }, [
                                  _vm._v("Безопасность")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { lg: "6" } },
                                      [
                                        _c(
                                          "b-card",
                                          { staticClass: "custom-card" },
                                          [
                                            _c(
                                              "b-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  [
                                                    _c("b-skeleton", {
                                                      attrs: {
                                                        type: "input",
                                                        width: "45%",
                                                        height: "72%"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  [
                                                    _c("b-skeleton", {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        width: "9%",
                                                        height: "17%"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("b-skeleton", {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        type: "input",
                                                        width: "100%",
                                                        height: "31%"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("b-skeleton", {
                                                      staticClass: "mb-0",
                                                      attrs: {
                                                        width: "86%",
                                                        height: "16%"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "b-tabs",
                      { staticClass: "custom-tabs", attrs: { card: "" } },
                      [
                        _c(
                          "b-tab",
                          {
                            attrs: { active: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "title",
                                fn: function() {
                                  return [
                                    _c("v-icon", {
                                      staticClass: "mr-2",
                                      attrs: { name: "tabs/user", size: 13 }
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Учётные данные")])
                                  ]
                                },
                                proxy: true
                              }
                            ])
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { lg: "6" } },
                                  [
                                    _c(
                                      "b-card",
                                      { staticClass: "custom-card" },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: "Имя пользователя",
                                              "invalid-feedback":
                                                _vm.nameInvalidFeedback,
                                              state: _vm.nameState
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                type: "text",
                                                size: "sm",
                                                state: _vm.nameState,
                                                trim: ""
                                              },
                                              model: {
                                                value: _vm.user.name,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.user,
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression: "user.name"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: "Email пользователя",
                                              "invalid-feedback":
                                                _vm.emailInvalidFeedback,
                                              state: _vm.emailState
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                type: "text",
                                                size: "sm",
                                                state: _vm.emailState,
                                                trim: ""
                                              },
                                              model: {
                                                value: _vm.user.email,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.user,
                                                    "email",
                                                    $$v
                                                  )
                                                },
                                                expression: "user.email"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: "Логин",
                                              "invalid-feedback":
                                                _vm.userNameInvalidFeedback,
                                              state: _vm.userNameState
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                type: "text",
                                                size: "sm",
                                                state: _vm.userNameState,
                                                trim: ""
                                              },
                                              model: {
                                                value: _vm.user.username,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.user,
                                                    "username",
                                                    $$v
                                                  )
                                                },
                                                expression: "user.username"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("h5", { staticClass: "my-2" }, [
                              _vm._v("Безопасность")
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { lg: "6" } },
                                  [
                                    _c(
                                      "b-card",
                                      { staticClass: "custom-card" },
                                      [
                                        _vm.isEdit
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "custom-btn-primary",
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.onChangePassword.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-icon", {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        name: "buttons/key",
                                                        size: 13
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Сбросить пароль\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass: "ml-2",
                                                    attrs: {
                                                      size: "sm",
                                                      variant:
                                                        "outline-secondary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        _vm.showCustomPassword = !_vm.showCustomPassword
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      Указать свой пароль\n                    "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.showCustomPassword
                                                  ? _c(
                                                      "b-form-group",
                                                      {
                                                        staticClass: "mt-2",
                                                        attrs: {
                                                          id:
                                                            "group-password-edit",
                                                          label: "Пароль",
                                                          description:
                                                            "Придумайте пароль, используя латиницу и спецсимволы, минимум 12 символов. Будет использоваться для входа в систему",
                                                          "invalid-feedback":
                                                            _vm.passwordInvalidFeedback,
                                                          state:
                                                            _vm.passwordState
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b-input-group",
                                                          [
                                                            _c("b-form-input", {
                                                              attrs: {
                                                                type: "text",
                                                                size: "sm",
                                                                state:
                                                                  _vm.passwordState,
                                                                trim: ""
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.password,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.password = $$v
                                                                },
                                                                expression:
                                                                  "password"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "b-input-group-append",
                                                              [
                                                                _c(
                                                                  "b-button",
                                                                  {
                                                                    attrs: {
                                                                      size:
                                                                        "sm",
                                                                      variant:
                                                                        "info"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.onPasswordReset.apply(
                                                                          null,
                                                                          arguments
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Сгенерировать новый"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c("b-form-text", [
                                                          _vm._v(
                                                            "Пароль будет применён после нажатия кнопки «Сохранить»"
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.isEdit
                                          ? _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-password",
                                                  label: "Пароль",
                                                  description:
                                                    "Придумайте Пароль используя латиницу и спецсимволы, минимум 12 символов. Будет использоваться для входа в систему",
                                                  "invalid-feedback":
                                                    _vm.passwordInvalidFeedback,
                                                  state: _vm.passwordState
                                                }
                                              },
                                              [
                                                _c(
                                                  "b-input-group",
                                                  [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        type: "text",
                                                        size: "sm",
                                                        state:
                                                          _vm.passwordState,
                                                        trim: ""
                                                      },
                                                      model: {
                                                        value: _vm.password,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.password = $$v
                                                        },
                                                        expression: "password"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-input-group-append",
                                                      [
                                                        _c(
                                                          "b-button",
                                                          {
                                                            attrs: {
                                                              size: "sm",
                                                              variant: "info"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.onPasswordReset.apply(
                                                                  null,
                                                                  arguments
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Сгенерировать новый"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            staticClass: "mt-2",
                                            model: {
                                              value: _vm.user.active,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.user,
                                                  "active",
                                                  $$v
                                                )
                                              },
                                              expression: "user.active"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.user.active
                                                    ? "Пользователь активен"
                                                    : "Пользователь неактивен"
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-tab",
                          {
                            scopedSlots: _vm._u([
                              {
                                key: "title",
                                fn: function() {
                                  return [
                                    _c("v-icon", {
                                      staticClass: "mr-2",
                                      attrs: { name: "navbar/roles", size: 13 }
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Права доступа")])
                                  ]
                                },
                                proxy: true
                              }
                            ])
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { lg: "6", md: "12" } },
                                  [
                                    _c(
                                      "b-card",
                                      { staticClass: "custom-card" },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              id: "group-role",
                                              label: "Роль"
                                            }
                                          },
                                          [
                                            _c(
                                              "b-form-select",
                                              {
                                                attrs: { size: "sm" },
                                                on: {
                                                  change: _vm.onSelectRole
                                                },
                                                model: {
                                                  value: _vm.user.role,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.user,
                                                      "role",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "user.role"
                                                }
                                              },
                                              _vm._l(_vm.roles, function(
                                                option
                                              ) {
                                                return _c(
                                                  "option",
                                                  {
                                                    domProps: {
                                                      value: option.code
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(option.name) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              }),
                                              0
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("p", [_vm._v("Разрешения")]),
                                        _vm._v(" "),
                                        _c(
                                          "b-list-group",
                                          {
                                            staticClass: "text-small",
                                            attrs: { "bg-variant": "light" }
                                          },
                                          _vm._l(_vm.treeData, function(
                                            item,
                                            index
                                          ) {
                                            return _c("PermissionListItem", {
                                              key: index,
                                              attrs: {
                                                item: item,
                                                "tree-data": _vm.treeData
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-tab",
                          {
                            scopedSlots: _vm._u([
                              {
                                key: "title",
                                fn: function() {
                                  return [
                                    _c("v-icon", {
                                      staticClass: "mr-2",
                                      attrs: { name: "tabs/link", size: 13 }
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Связи")])
                                  ]
                                },
                                proxy: true
                              }
                            ])
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { lg: "6", md: "12" } },
                                  [
                                    _c(
                                      "b-card",
                                      { staticClass: "custom-card" },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: "Штатный сотрудник"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              [
                                                _c("staff-select", {
                                                  ref: "staff_select",
                                                  on: {
                                                    onSelect: _vm.updateStaffId
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "passwordModal",
          attrs: {
            title: "Новый пароль",
            "hide-footer": "",
            size: "sm",
            centered: ""
          }
        },
        [
          _c("b-form-text", { staticClass: "mb-2" }, [
            _vm._v(
              "Пароль успешно изменён. Сохраните его — показать его снова будет невозможно."
            )
          ]),
          _vm._v(" "),
          _c(
            "b-input-group",
            [
              _c("b-form-input", {
                attrs: {
                  type: "text",
                  readonly: "",
                  value: _vm.generatedPassword
                }
              }),
              _vm._v(" "),
              _c(
                "b-input-group-append",
                [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "info" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.copyGeneratedPassword.apply(
                            null,
                            arguments
                          )
                        }
                      }
                    },
                    [_vm._v("Скопировать")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54d8a8c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54d8a8c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/User.vue
// module id = null
// module chunks = 